import { BaseAnnotationControl } from "@/viewer/BaseAnnotationControl";
import Select from "ol/interaction/Select";
import { FEATURE_STATUS } from "@/constants";

export default class DeleteControl extends BaseAnnotationControl {
  constructor({
    target = null,
    element = null,
    source = null,
    callback = null
  }) {
    super({
      target,
      element,
      source
    });
    const interaction = new Select({
      source
      // condition: ol.events.condition.click,
      // multi: options.multi || false
    });
    interaction.on("select", evt => {
      console.log("del sel", evt);
      callback(evt)
        .then(data => {
          evt.selected.forEach(f => {
            super.source.removeFeature(f);
            //   // if item selected, delete from db
            //   this.deleteAnnoFromDB(f);
            //   this.selectInteraction.getFeatures().clear();
          });
        })
        .catch(e => {
          // rejected when status is not created
        });
      // callback(evt);
    });
    super.interaction = interaction;
  }

  activate() {
    super.activate();
    super.map.getViewport().style.cursor = "pointer";
    // this.map.on("pointermove", this.hoverFeatures);
  }

  deactivate() {
    super.deactivate();
    // this.map.on("pointermove", this.hoverFeatures);
  }
}
